import React from "react";
import { Link } from "react-router-dom";
import Logo from "./Logo";
import { ShieldCheck, Lock, MapPin, FileCheck } from "lucide-react";

export default function MarketingFooter() {
  const year = new Date().getFullYear();
  return (
    <footer className="bg-navy-900 text-white" data-testid="marketing-footer">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-16 grid grid-cols-1 md:grid-cols-3 gap-12">
        <div>
          <Logo variant="light" size="lg" />
          <p className="mt-5 text-white/60 t-body max-w-sm">
            FCA-aware client onboarding with real-time compliance checking and an immutable audit trail. Built in the UK, hosted in the UK.
          </p>
          <div className="mt-6 flex flex-wrap gap-2">
            <span className="badge2 badge-verified" style={{ background: "rgba(16,185,129,0.12)", color: "#A7F3D0", borderColor: "rgba(16,185,129,0.35)" }}>
              <ShieldCheck size={12} /> FCA-AWARE
            </span>
            <span className="badge2 badge-verified" style={{ background: "rgba(16,185,129,0.12)", color: "#A7F3D0", borderColor: "rgba(16,185,129,0.35)" }}>
              <Lock size={12} /> GDPR
            </span>
            <span className="badge2 badge-verified" style={{ background: "rgba(16,185,129,0.12)", color: "#A7F3D0", borderColor: "rgba(16,185,129,0.35)" }}>
              <MapPin size={12} /> UK HOSTED
            </span>
          </div>
        </div>

        <div className="grid grid-cols-2 gap-8 md:col-span-1">
          <div>
            <div className="t-label text-white/40 mb-4">Product</div>
            <ul className="space-y-3 t-body-sm text-white/70">
              <li><Link to="/#features" className="hover:text-white">Features</Link></li>
              <li><Link to="/#pricing" className="hover:text-white">Pricing</Link></li>
              <li><Link to="/security" className="hover:text-white">Security</Link></li>
              <li><Link to="/#scanner" className="hover:text-white">Free Scanner</Link></li>
              <li><Link to="/signup" className="hover:text-white">Start Free Trial</Link></li>
              <li><Link to="/login" className="hover:text-white">Sign in</Link></li>
            </ul>
          </div>
          <div>
            <div className="t-label text-white/40 mb-4">Company</div>
            <ul className="space-y-3 t-body-sm text-white/70">
              <li><a href="mailto:hello@compliche.com" className="hover:text-white">Contact</a></li>
              <li><Link to="/security#disclosure" className="hover:text-white">Vulnerability disclosure</Link></li>
              <li><a href="mailto:security@compliche.com" className="hover:text-white">Security contact</a></li>
              <li><Link to="/#how" className="hover:text-white">How it works</Link></li>
            </ul>
          </div>
        </div>

        <div>
          <div className="t-label text-white/40 mb-4">Legal</div>
          <ul className="space-y-3 t-body-sm text-white/70">
            <li><Link to="/security#compliance" className="hover:text-white">Privacy &amp; GDPR</Link></li>
            <li><Link to="/security#audit" className="hover:text-white">Audit &amp; retention</Link></li>
            <li><Link to="/security#encryption" className="hover:text-white">Encryption policy</Link></li>
            <li><Link to="/security#disclosure" className="hover:text-white"><FileCheck size={14} className="inline mr-1" />Security disclosure</Link></li>
          </ul>
        </div>
      </div>

      <div className="border-t border-white/5">
        <div className="max-w-7xl mx-auto px-6 lg:px-10 py-6 flex flex-col md:flex-row items-start md:items-center justify-between gap-4 text-xs text-white/50">
          <div>© {year} Compliche Ltd. All rights reserved. · Company No. 14829347 (placeholder)</div>
          <div className="t-mono">FCA-Aware · GDPR Compliant · UK-Built · UK-Hosted</div>
        </div>
      </div>
    </footer>
  );
}
